var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{directives:[{name:"scroll-to",rawName:"v-scroll-to",value:({
    el: _vm.bottom ? '#start-view' : '#one-page-down',
    duration: 500,
    easing: 'linear'
  }),expression:"{\n    el: bottom ? '#start-view' : '#one-page-down',\n    duration: 500,\n    easing: 'linear'\n  }"}],staticClass:"scroll-down"},[_vm._v("\n  "+_vm._s(_vm.bottom ? 'Scroll up' : 'Scroll down')),_c('br'),_c('i',{staticClass:"fa",class:{'fa-caret-down': !_vm.bottom, 'fa-caret-up': _vm.bottom }})])}
var staticRenderFns = []

export { render, staticRenderFns }